import React, { Component } from 'react';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Input from '../Input';
import Row from '../Row';
import Toast from '../Toast/Toast';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import 'react-toastify/dist/ReactToastify.css';
import Editor from './Editor';
import { fetchEmailTemplates, updateEmailTemplate, setEmailTemplateForm, clearEmailTemplateForm, setEmailTemplates, clearEmailTemplates } from '../../store/actions/emailTemplates';

class EmailTemplateForm extends Component {
  onUpdateTemplate=()=>{
    const {updateEmailTemplate} = this.props;
    const {emailTemplatesForm}=this.props.emailTemplates;
    updateEmailTemplate(emailTemplatesForm)
  }
  render() {
    const { onClose, breadcrumb, setEmailTemplateForm,user, loader } = this.props;
    const {emailTemplates, emailTemplatesForm}=this.props.emailTemplates;
    const validateSubjectAndBody = emailTemplatesForm.subject === '' || emailTemplatesForm.body === ''
    return (
      <Form
        headline={"Update Email Template"}
        onClose={() => onClose()}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            <Button
              color="teal"
              size="small"
              label="Update Email Template"
              onClick={() =>this.onUpdateTemplate()}
              disabled={validateSubjectAndBody?true:false }
            />
          </>
        }
        component={
          <>
            <Row mdCenter>
              <Col xs="12" md="6">
                {breadcrumb && (
                  <>
                    <Toast
                      message={
                        <>
                          You are about to update this email template. Make sure to NOT change the variables (anything that starts with @) in the Subject or Content.
                        </>
                      }
                    />
                    <br />
                    <br />
                  </>
                )}
                <Input
                  value={emailTemplatesForm.subject}
                  onChange={(e) => setEmailTemplateForm({...emailTemplatesForm, subject: e.target.value })}
                  label="Subject"
                  required
                  placeholder="Subject"
                  block
                />
                <div className="input">
                  <div className="input__require">
                    <label className="input__label">Content</label>
                    <div className="input__required" />
                  </div>
                </div>
                <div class style={{border: '0.1rem solid rgba(83, 83, 83, 0.25)', padding:"20px 30px 50px 30px"}}>
                <Editor
                  onUpdateTemplate={()=>this.onUpdateTemplate()}
                  htmlContent={`${emailTemplatesForm.body}`}
                  updateHtmlContent={(html)=>setEmailTemplateForm({...emailTemplatesForm,body:html})}
                />
                </div>
              </Col>
            </Row>
          </>
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  user:selectAuthenticatedUser(state),
  loader: selectFormLoader(state),
  emailTemplates:state.emailTemplates,
})


const mapDispatchToProps = dispatch => bindActionCreators({
  fetchEmailTemplates,
  updateEmailTemplate,
  setEmailTemplateForm, 
  clearEmailTemplateForm, 
  setEmailTemplates,
  clearEmailTemplates
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateForm);

